import CityPageTemplate from "../city-template/CityPageTemplate";
import { windhamConfig } from "./data";

export default function WindhamPage() {
  return <CityPageTemplate config={windhamConfig} />;
}